/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { When } from "react-if";
import { theme, Box } from "@nordcloud/gnui";
import { getMessage, NoData } from "~/components/NoData";

type Props = {
  show: boolean;
  width: number;
  height: number;
};

export function ChartPlaceholder({ show, width, height }: Props) {
  return (
    <When condition={show}>
      <Box
        color={theme.colors.lights[0]}
        css={{
          position: "absolute",
          height: `${height}px`,
          width: `${width}px`,
        }}
      >
        <NoData message={getMessage("No data available.")} renderOnTop />
      </Box>
    </When>
  );
}
